import { z } from "zod";

import {
  CreditTxPurchaseMetaSchema,
  CreditTxReferralRewardMetaSchema,
  CreditTxSchema,
  CreditTxTicketSoldMetaSchema,
  CreditTxTypeEnumSchema,
  CreditTxUsageMetaSchema,
  PurchaseMethodEnumSchema
} from "../models";

// Credit transaction with meta API response schema
export const CreditTxWithMetaSchema = z.discriminatedUnion("type", [
  CreditTxSchema.extend({
    type: z.literal(CreditTxTypeEnumSchema.enum.PAYMENT),
    purchaseMeta: CreditTxPurchaseMetaSchema,
    usageMeta: CreditTxUsageMetaSchema,
    referralMeta: z.null().optional(),
    ticketSoldMeta: z.null().optional()
  }),
  CreditTxSchema.extend({
    type: z.literal(CreditTxTypeEnumSchema.enum.PURCHASE),
    purchaseMeta: CreditTxPurchaseMetaSchema,
    usageMeta: z.null().optional(),
    referralMeta: z.null().optional(),
    ticketSoldMeta: z.null().optional()
  }),
  CreditTxSchema.extend({
    type: z.literal(CreditTxTypeEnumSchema.enum.USAGE),
    purchaseMeta: z.null().optional(),
    usageMeta: CreditTxUsageMetaSchema,
    referralMeta: z.null().optional(),
    ticketSoldMeta: z.null().optional()
  }),
  CreditTxSchema.extend({
    type: z.literal(CreditTxTypeEnumSchema.enum.REFERRAL),
    purchaseMeta: z.null().optional(),
    usageMeta: z.null().optional(),
    referralMeta: CreditTxReferralRewardMetaSchema,
    ticketSoldMeta: z.null().optional()
  }),
  CreditTxSchema.extend({
    type: z.literal(CreditTxTypeEnumSchema.enum.TICKET_SOLD),
    purchaseMeta: z.null().optional(),
    usageMeta: z.null().optional(),
    referralMeta: z.null().optional(),
    ticketSoldMeta: CreditTxTicketSoldMetaSchema
  }),
  CreditTxSchema.extend({
    // DEPRECATED
    type: z.literal(CreditTxTypeEnumSchema.enum.BONUS),
    purchaseMeta: z.null().optional(),
    usageMeta: z.null().optional(),
    referralMeta: z.null().optional(),
    ticketSoldMeta: z.null().optional()
  })
]);

// export const CreditTxWithMetaSchema = CreditTxSchema.extend({
//   purchaseMeta: CreditTxPurchaseMetaSchema.nullable(),
//   usageMeta: CreditTxUsageMetaSchema.nullable(),
//   referralMeta: CreditTxReferralRewardMetaSchema.nullable(),
// });
export type CreditTxWithMeta = z.infer<typeof CreditTxWithMetaSchema>;

// ------------------------------------------------------------------------------------------------
// API Request & Response schemas
export const CreatePaymentRequestSchema = z.object({
  amount: z.number().positive().min(1),
  method: PurchaseMethodEnumSchema
});
export type CreatePaymentRequest = z.infer<typeof CreatePaymentRequestSchema>;

export const CreatePaymentRequestRespSchema = z.object({
  checkoutUrl: z.string(),
  qrCode: z.string(),
  creditTx: CreditTxWithMetaSchema
});
export type CreatePaymentRequestResp = z.infer<typeof CreatePaymentRequestRespSchema>;
